import * as React from "react";
import EachService from "./EachService";
import { serviceDetails } from "./serviceDetails";

export default function CustomizedDialogs(props) {
	let index = serviceDetails.indexOf(serviceDetails.find((x) => x.panel === props.open));

	return (
		props.open && (
			<EachService
				key={serviceDetails[index].id}
				service={serviceDetails[index]}
				panel={props.open}
				handleClose={props.handleClose}
				name={serviceDetails[index].name}
				description={serviceDetails[index].description}
			/>
		)
	);

	// <>
	//   <CarAccidents panel={props.open} handleClose={props.handleClose} />
	//   <DwiCrashes panel={props.open} handleClose={props.handleClose} />
	//   {/* <Wheelers panel={props.open} handleClose={props.handleClose} /> */}
	//   <Death panel={props.open} handleClose={props.handleClose} />
	//   <Slip panel={props.open} handleClose={props.handleClose} />
	//   <Bites panel={props.open} handleClose={props.handleClose} />
	//   <Medical panel={props.open} handleClose={props.handleClose} />
	//   <Shootings panel={props.open} handleClose={props.handleClose} />
	// </>
}
